import React from 'react';
import PropTypes from 'prop-types';
import { MenuBar, Icon, Button } from 'Components';
import i18n from 'i18next';
import rowRules from 'helpers/rowRules';
import menuOptions from 'constants/menuOptions';
import DownloadFromUrl from 'helpers/download';
import { SUBMISSIONS } from 'constants/apis';
import './MobileItemBody.css';

const handleClick = (e, URL) => {
  e.stopPropagation();
  DownloadFromUrl(URL);
};

const jobFilesData = SubmissionId => [
  {
    Description: i18n.t('jobs:Tracking Form'),
    url: `${SUBMISSIONS}/${SubmissionId}/GetPhysicalTrackingForm`,
  },
  {
    Description: i18n.t('jobs:eCOC Submission Summary'),
    url: `${SUBMISSIONS}/${SubmissionId}/GetGenericPDF?SummaryFormat=true`,
  },
  {
    Description: i18n.t('jobs:eCOC Submission Details'),
    url: `${SUBMISSIONS}/${SubmissionId}/GetGenericPDF?SummaryFormat=false`,
  },
];

const MobileItemBody = ({
  data,
  onOptionClick,
  tableIndex,
  mobileKeys,
  keyPairs,
  userName,
}) => (
  <div className="mobile-item-body">
    <MenuBar
      icons={menuOptions.filter(option => rowRules[mobileKeys.code](option, data, userName))}
      tableIndex={tableIndex}
      onClick={(code, index) => onOptionClick(code, index)}
      show
    />
    {mobileKeys.code === 'job' && data.Status !== 'C' && data.SubmissionId !== 0 &&
      <div className="mobile-item-body__job-files">
        {
          jobFilesData(data.SubmissionId).map(obj => (
            <Button className="mobile-item-body__job-files__file" key={obj.Description} onClick={e => handleClick(e, obj.url)}>
              <div>
                <Icon icon="description" />
                <span>{obj.Description}</span>
              </div>
            </Button>
          ))
        }
      </div>
    }
    {data.LockTemplate &&
    <div className="mobile-item-body__lock-icon">
      <Icon icon="lock" />
    </div>}
    {mobileKeys.bodyKeys &&
    <div className="mobile-item-body__content">
      {mobileKeys.bodyKeys.map(item => (
        <div key={keyPairs[item] + data[item]}>
          <div>
            <h3>{keyPairs[item]}</h3>
            <span>{data[item] === '' ? '—' : data[item]}</span>
          </div>
        </div>
      ))}
    </div>}
  </div>
);

MobileItemBody.propTypes = {
  userName: PropTypes.string,
  data: PropTypes.shape({}),
  keyPairs: PropTypes.shape({}),
  mobileKeys: PropTypes.shape({}),
  onOptionClick: PropTypes.func,
  tableIndex: PropTypes.number,
};
export default MobileItemBody;



// WEBPACK FOOTER //
// ./src/components/MobileItemList/MobileItemBody/MobileItemBody.jsx